import { hasAccess } from '@/mixins/hasAccess.mixin'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES, UserRole } from './constants'
import { useSessionStore } from '@/stores/session'

export function getDefaultRoute() {
  const sessionStore = useSessionStore()
  const user = sessionStore.getUser()

  if (user && user.roles.length === 1 && user.roles[0] === UserRole.SALES) {
    return ROUTES.POS_NEW_ORDER
  }
  if (hasAccess(ACTION_ROLES.ORDERS_VIEW)) {
    return ROUTES.ORDERS
  }
  if (hasAccess(ACTION_ROLES.SCANS_VIEW)) {
    return ROUTES.SCANS
  }
  return '/'
}
